import { useState } from 'react';

import { Grid } from '@mui/material';

import { CissTextField } from 'components/fields';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function MensagemPadraoGridFilter() {
    const [filterDsTitulo, setFilterDsTitulo] = useState<FilterValuesProps>({
        property: 'dsTitulo',
        operator: 'like',
        value: null,
        idProperty: 'dsTitulo',
    });

    return (
        <Filter filters={[{ value: filterDsTitulo, setter: setFilterDsTitulo }]} preventQueryParamsEmptyStart>
            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="Descrição"
                    value={filterDsTitulo.value}
                    onChange={(e) => setFilterDsTitulo((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
        </Filter>
    );
}
